import { ValidationError } from "sequelize"
import {
    CcReviewReviewType,
    CcReviewReviewTypeCreate,
    CcReviewReviewTypeSave,
} from "server/models"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import { ASC } from "const"
import {
    CcReviewReviewTypeList,
    CcReviewReviewTypeValidation,
} from "./types"


export const LoadCcReviewReviewTypes = (
    accountId: number,
    projectId: number,
) => (
    GET(`/ccReviewReviewType/accountId/${accountId}/projectId/${projectId}`)
    .then((types: CcReviewReviewType[]) => {
        const typeList: CcReviewReviewTypeList = {}
        types.forEach((type) => {
            typeList[type.id] = type
        })

        const typesSorted = types.sort((a, b) => sort(a, b, "order", ASC))
        const typeIds: number[] = []
        typesSorted.forEach((type) => {
            typeIds.push(type.id)
        })

        return { typeList, typeIds }
    })
)

export const LoadCcReviewReviewTypeById = (
    typeId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccReviewReviewType/id/${typeId}/accountId/${accountId}/projectId/${projectId}`)
    .then((type: CcReviewReviewType) => type)
)

export const SaveCcReviewReviewType = (
    id: number,
    type: CcReviewReviewTypeCreate,
    lang: LangType,
) => {
    const data: CcReviewReviewTypeSave = {
        id,
        type,
    }
    return POST(
        "/ccReviewReviewType/save",
        JSON.stringify(data),
    ).then((res) => {
        const newType = res as CcReviewReviewType
        const error = res as ValidationError
        return {
            newTypeId: newType.id || null,
            newTypeOrder: newType.order || null,
            validation: <CcReviewReviewTypeValidation>validate(error, lang),
        }
    })
}

export const DragnDropCcReviewReviewType = (
    typeIds: readonly number[],
    typeList: CcReviewReviewTypeList,
) => {
    const data: CcReviewReviewType[] = []
    typeIds.forEach((id, index) => {
        data.push({
            ...typeList[id],
            order: index,
        })
    })

    return POST(
        "/ccReviewReviewType/updateMany",
        JSON.stringify(data),
    ).then((success: boolean) => success)
}

export const DeleteCcReviewReviewType = (typeId: number) => (
    DELETE(`/ccReviewReviewType/delete/${typeId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcReviewReviewTypes = (
    accountId: number,
    projectId: number,
    defaultTypesAssigned: boolean,
) => (
    GET(`/ccReviewReviewType/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultTypesAssigned}`)
    .then((success: boolean) => success)
)
